import jsPDF from "jspdf";
import "jspdf-autotable";

export const generatePDF = (Estudiante) => {
  let estudiante = JSON.parse(Estudiante);
  //const doc = new jsPDF();
  const doc = new jsPDF({
    format: 'A4',
  });
  const tableColumnTI = "";
    const tableRowsTI= [];
    const tableColumnPie = "";
    const tableRowsPie= [];



  const tableColumnTit = "";
  const tableRowsTit = [];
  var ciclo = "";
  if (estudiante[0].ciclo_nivel == 1) { ciclo = "PRIMER"; }
  if (estudiante[0].ciclo_nivel == 2) { ciclo = "SEGUNDO"; }
  if (estudiante[0].ciclo_nivel == 3) { ciclo = "TERCER"; }
  if (estudiante[0].ciclo_nivel == 4) { ciclo = "CUARTO"; }
  if (estudiante[0].ciclo_nivel == 5) { ciclo = "QUINTO"; }
  if (estudiante[0].ciclo_nivel == 6) { ciclo = "SEXTO"; }

  doc.setFont("Cambria");
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);

  const encabezado = [
    "CERTIFICADO DE PASE DE CICLO",
    " ",
  ];

  tableRowsTit.push(encabezado);

  const carrera = [
    estudiante[0].descripcion_carrera.toUpperCase(),
    " ",
  ];

  tableRowsTit.push(carrera);

  const periodo = [
    estudiante[0].descripcion_periodo_academico.toUpperCase(),
    " ",
  ];

  tableRowsTit.push(periodo);

  doc.autoTable(tableColumnTit, tableRowsTit, {
    startY: 36, styles: {
      fontSize: 16,
      // background: FF5733,
      font: 'Cambria'
    },
    margin: { left: 30 },
    headStyles: {
      fillColor: '#FFFFFF',
      textColor: '#FF5733',
      halign: 'center'
    },
    bodyStyles: {
      // halign: 'center',
      fillColor: '#FFFFFF',
      textColor: '#000000',
    },
    columnStyles: {
      0: {
        halign: "center",
        textColor: '#000000',
        fontStyle: 'bold',
        columnWidth: 150
      }
    },
    alternateRowStyles: {
      fillColor: '#FFFFFF',
    },
  });

  
//uno
//Nombre del Documento
const texto_inicial = [
    "CERTIFICO: que el (a) señor (ra,ita) " + estudiante[0].primer_nombre_estudiante + " " + estudiante[0].segundo_nombre_estudiante + " " + estudiante[0].primer_apellido_estudiante + " " + estudiante[0].segundo_apellido_estudiante + " estudiante del " + ciclo + " CICLO, ha cursado las asignaturas con las equivalencias respectivas, según consta en el correspondiente Libro de Calificaciones:",
    " ",
];

tableRowsTI.push(texto_inicial);
doc.autoTable(tableColumnTI, tableRowsTI, {
  startY: 71, styles: {
    fontSize: 12,
    font: 'Cambria'
  },
  margin: { left: 30 },
  columnStyles: {
    0: {
      halign: "justify",
      textColor: '#000000',
     
    },
  },
  alternateRowStyles: {
    fillColor: '#FFFFFF',
  }
});
//fin uno
  const tableColumn = "";
  const tableRows = [];

  doc.setFont("Cambria");
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);

  const espacioencab = [
    "ASIGNATURAS",
    "NOTA FINAL",
    "CRÉDITOS",
    "ESTADO",
  ];
  tableRows.push(espacioencab);

  var asignatura = [];
  for (let i = 0; i < estudiante.length; i++) {
    var promp = (estudiante[i].parcial1 + estudiante[i].parcial2 + estudiante[i].parcial3) / 3;
    var promp = (promp * 6) / 10;
    var examfinal = (estudiante[i].examen_final * 4) / 10;
    var promacumulado = promp + examfinal;
    //var promfinal = promacumulado >= 7 ? promacumulado : (promacumulado + estudiante[i].examen_suspension) / 2;
    var promfinal = 0.00;
    if (promacumulado >= 7) {
      promfinal = promacumulado;
    }
    else {
      if (((promacumulado >= 4) && (promacumulado < 7)) && (estudiante[i].examen_suspension == 0))
        promfinal = promacumulado;
      else
        if (((promacumulado >= 4) && (promacumulado < 7)) && (estudiante[i].examen_suspension > 0))

          promfinal = (promacumulado + estudiante[i].examen_suspension) / 2;
        else
          promfinal = promacumulado;
    }
    var promfinal = promfinal.toFixed(2);
    asignatura = [
      estudiante[i].descripcion_asignatura,
      promfinal,
      estudiante[i].creditos_asignatura,
      estudiante[i].equivalencia == 0 ? "REPROBADO" : "APROBADO"
    ];
    tableRows.push(asignatura);
  }

  doc.autoTable(tableColumn, tableRows, {
    tableLineColor: [0, 0, 0],
    tableLineWidth: 1,
    tableWidth: 150,
    startY: 100, styles: {
      fontSize: 10,
      // background: FF5733,
      font: 'Cambria'
    },
    margin: { left: 30 },
    headStyles: {
      fillColor: '#FFFFFF',
      textColor: '#FF5733',
      halign: 'center'
    },
    bodyStyles: {
      // halign: 'center',
      fillColor: '#FFFFFF',
      textColor: '#000000',
      lineWidth: 0.2,
      lineColor: [0, 0, 0]
    },
    columnStyles: {
      0: {
        halign: "left",
        textColor: '#000000',
        fontStyle: 'bold',
        columnWidth: 60,
      },
      1: {
        halign: "Justify",
        textColor: '#000000',
        fontStyle: 'bold',
        halign: "Justify",
        //cellWidth: 60,
        columnWidth: 15
      },
      2: {
        halign: "Justify",
        textColor: '#000000',
        fontStyle: 'bold',
        halign: "Justify",
        //cellWidth: 60,
        columnWidth: 30
      },
      3: {
        halign: "Justify",
        textColor: '#000000',
        fontStyle: 'bold',
        halign: "Justify",
        //cellWidth: 60,
        columnWidth: 45
      },
    },
    alternateRowStyles: {
      fillColor: '#FFFFFF',
    },
  });

  var dia = new Date().getDate();
  var mes = new Date().toLocaleString('es-es', { month: 'long' });;
  var anio = new Date().getFullYear();
  const tableColumnFec = "";
  const tableRowsFec = [];

  const fecha = [
    "RIOBAMBA, " + dia + " de " + mes + " del " + anio,
  ];

  tableRowsFec.push(fecha);

  doc.autoTable(tableColumnFec, tableRowsFec, {
    startY: 200, styles: {
      fontSize: 10,
      // background: FF5733,
      font: 'Cambria'
    },
    margin: { left: 30 },
    headStyles: {
      fillColor: '#FFFFFF',
      textColor: '#FF5733',
      halign: 'center'
    },
    bodyStyles: {
      // halign: 'center',
      fillColor: '#FFFFFF',
      textColor: '#000000',
    },
    columnStyles: {
      0: {
        halign: "right",
        textColor: '#000000',
        columnWidth: 150
      }
    },
    alternateRowStyles: {
      fillColor: '#FFFFFF',
    },
  });

  const tableColumnFir = "";
  const tableRowsFir = [];

  const firma1 = [
    "_______________________________",
  ];

  tableRowsFir.push(firma1);

  const firma2 = [
    "Tnlga. Fanny Barriga",
  ];

  tableRowsFir.push(firma2);

  const firma3 = [
    "SECRETARIA GENERAL ISTMAS",
  ];

  tableRowsFir.push(firma3);

  doc.autoTable(tableColumnFir, tableRowsFir, {
    startY: 220, styles: {
      fontSize: 10,
      // background: FF5733,
      font: 'Cambria'
    },
    margin: { left: 30 },
    headStyles: {
      fillColor: '#FFFFFF',
      textColor: '#FF5733',
      halign: 'center'
    },
    bodyStyles: {
      // halign: 'center',
      fillColor: '#FFFFFF',
      textColor: '#000000',
    },
    columnStyles: {
      0: {
        halign: "center",
        textColor: '#000000',
        fontStyle: 'bold',
        columnWidth: 150
      }
    },
    alternateRowStyles: {
      fillColor: '#FFFFFF',
    },
  });

  //Nombre del Documento
const pie = [
  "Este certificado tiene valor si lleva firma y sello de la Secretaría del Instituto. Cualquier alteración al texto del presente documento con añadiduras, abreviaturas, borrones, etc. Lo invalida.",
];

tableRowsPie.push(pie);

doc.autoTable(tableColumnPie, tableRowsPie, {
startY: 250, styles: {
  fontSize: 8,
  font: 'Cambria'
},
margin: { left: 30 },
columnStyles: {
  0: {
    halign: "justify",
    textColor: '#000000',
    fontStyle: 'bold',
   
  },
},
alternateRowStyles: {
  fillColor: '#FFFFFF',
}
});
//fin uno


  /*const tableColumnPie = "";
  const tableRowsPie = [];

  const pie = [
    "Este certificado tiene valor si lleva firma y sello de la Secretaría del Instituto. Cualquier alteración al texto del presente documento con añadiduras, abreviaturas, borrones, etc. Lo invalida.",
  ];

  tableRowsPie.push(pie);

  doc.autoTable(tableColumnPie, tableRowsPie, {
    //tableWidth: 150,
    startY: 250, styles: {
      fontSize: 8,
      // background: FF5733,
      font: 'Cambria'
    },
    margin: { left: 30 },
    headStyles: {
      fillColor: '#FFFFFF',
      textColor: '#FF5733',
      halign: 'center'
    },
    bodyStyles: {
      // halign: 'center',
      fillColor: '#FFFFFF',
      textColor: '#000000',
    },
    columnStyles: {
      0: {
        halign: "left",
        textColor: '#000000',
        fontStyle: 'bold',
        //columnWidth: 140
      }
    },
    alternateRowStyles: {
      fillColor: '#FFFFFF',
    },
  });*/

  const tableColumnPie2 = "";
  const tableRowsFecPie2 = [];

  const pie2 = [
    "Dirección: Loja 31-15 y Buenos Aires, Riobamba",
  ];

  tableRowsFecPie2.push(pie2);

  const pie3 = [
    "Teléfono Fijo: 03-2961680  Teléfono Móvil: 0988183081",
  ];

  tableRowsFecPie2.push(pie3);

  const pie4 = [
    "      www.istmas.edu.ec",
  ];

  tableRowsFecPie2.push(pie4);

  doc.autoTable(tableColumnPie2, tableRowsFecPie2, {
    startY: 265, styles: {
      fontSize: 9,
      // background: FF5733,
      font: 'Cambria'
    },
    margin: { left: 30 },
    headStyles: {
      fillColor: '#FFFFFF',
      textColor: '#FF5733',
      halign: 'right'
    },
    bodyStyles: {
      // halign: 'center',
      fillColor: '#FFFFFF',
      textColor: '#000000',
      cellPadding: 0.5,
    },
    columnStyles: {
      0: {
        halign: "right",
        textColor: '#000000',
        columnWidth: 150
      }
    },
    alternateRowStyles: {
      fillColor: '#FFFFFF',
    },
  });

  doc.setFont("Cambria");
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.addImage("data:image/png;base64,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", 118, 0.5, 80, 38);
  doc.setFont("Cambria");
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(11);
  //doc.text(" LOJA 3115 Y BUENOS AIRES  TELEF.032961680", 55, 35);
  //doc.text("RIOBAMBA-ECUADOR", 75, 40);
  doc.setFontSize(18);
  //doc.text("CARRERA: "+estudiante[0].descripcion_carrera.toUpperCase(), 30, 50);
  //doc.text("PERIODO ACADÉMICO: "+estudiante[0].descripcion_periodo_academico.toUpperCase(), 30, 57);
  //doc.text("CERTIFICO: que el (a) señor (ra,ita) "+estudiante[0].primer_nombre_estudiante+" "+estudiante[0].segundo_nombre_estudiante+" "+estudiante[0].primer_apellido_estudiante+" "+estudiante[0].segundo_apellido_estudiante+" estudiante del asdasd asdasd adasdasd asdasdasda asdasdasdasd asdasd asdasda", 30, 67);
  doc.save("matricula.pdf");
};

export default generatePDF;